module.exports = __webpack_public_path__ + "public/SiteIcons/exitpageIconOne.svg?2b3b2d7f";